import { RequirementDefinitionTransitionScope } from "@wingspanhq/wingspan-api-sdk";
import React from "react";

export const getContractorsCurrentValue = (
  scope: RequirementDefinitionTransitionScope,
  completeCount: number,
  incompleteCount: number
): {
  primary: React.ReactNode;
  secondary?: React.ReactNode;
  disabled?: boolean;
} => {
  switch (scope) {
    case RequirementDefinitionTransitionScope.ALL:
      return {
        disabled: true,
        primary: "—",
        secondary: "None (all transitioning to new)"
      };
    case RequirementDefinitionTransitionScope.INCOMPLETE_AND_NEW:
      return { primary: `${completeCount} complete` };
    case RequirementDefinitionTransitionScope.NEW_ONLY:
      return {
        primary: `${completeCount} complete`,
        secondary: `${incompleteCount} incomplete`
      };
  }
};

export const getContractorsNewValue = (
  scope: RequirementDefinitionTransitionScope,
  completeCount: number,
  incompleteCount: number
): { primary: React.ReactNode; secondary?: React.ReactNode } => {
  switch (scope) {
    case RequirementDefinitionTransitionScope.ALL:
      return {
        primary: React.createElement(
          React.Fragment,
          null,
          `${completeCount} complete`,
          React.createElement("br"),
          `${incompleteCount} incomplete`
        ),
        secondary: "+ new assignments"
      };
    case RequirementDefinitionTransitionScope.INCOMPLETE_AND_NEW:
      return {
        primary: `${incompleteCount} incomplete`,
        secondary: "+ new assignments"
      };
    case RequirementDefinitionTransitionScope.NEW_ONLY:
      return { primary: "New assignments" };
  }
};
